<template>
  <div class="max-w-6xl mx-auto">
    <!-- Competition Header -->
    <CompetitionHeader
      v-if="competition"
      :competition="competition"
      :participant-count="0"
      :show-delete-button="false"
    />

    <!-- Moderation Content -->
    <div class="mt-8">
      <PendingRequests :competition-id="competitionId" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useCompetitionStore } from '../stores/competition'
import CompetitionHeader from '../components/CompetitionHeader.vue'
import PendingRequests from '../components/PendingRequests.vue'

const route = useRoute()
const competitionStore = useCompetitionStore()

const competitionId = route.params.id
const competition = ref(null)
const loading = ref(false)
const error = ref('')

const fetchCompetition = async () => {
  loading.value = true
  error.value = ''
  
  try {
    competition.value = await competitionStore.fetchCompetition(competitionId)
  } catch (err) {
    error.value = err.message || 'Failed to load competition'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  if (competitionId) {
    fetchCompetition()
  } else {
    error.value = 'No competition ID provided'
  }
})
</script> 